// import React from 'react'
// import Landingscreen from './Landingscreen'
// import About from './About'
// import Projects from './Projects'
// import ContactUs from './ContactUs'
// import Footer from './Footer'
// import TransformationShowcase from './TransformationShowcase'
// import VideoShowcase from './VideoShowcase'
// import ClientFeedbacks from './ClientFeedbacks'
// import WhyChooseUs from './WhyChooseUs'
// import AboutFounder from './AboutFounder'


// const Homescreen = () => {
//     return (
//         <div>
//             <Landingscreen />
//             <Projects />
//             <TransformationShowcase />
//             <VideoShowcase />
//             <About />
//             <ClientFeedbacks />
//             {/* <WhyChooseUs /> */}
//             <AboutFounder />
//             <ContactUs />
//             <Footer />
//         </div>
//     )
// }

// export default Homescreen


import React, { useState, useEffect } from 'react';
import Landingscreen from './Landingscreen';
import About from './About';
import Projects from './Projects';
import ContactUs from './ContactUs';
import Footer from './Footer';
import TransformationShowcase from './TransformationShowcase';
import VideoShowcase from './VideoShowcase';
import ClientFeedbacks from './ClientFeedbacks';
import AboutFounder from './AboutFounder';
import MeetOurTeam from './MeetOurTeam';
import RecentWorkShowcase from './RecentWorkShowcase';
import DesignProcess from './DesignProcess';

const Homescreen = () => {
    const [currentViewedSection, setCurrentViewedSection] = useState('home');

    // Passive Scroll Interaction Listener Tracker
    useEffect(() => {
        const sectionsToTrack = ['home', 'projects', 'about', 'contact'];

        const handleScrollTracking = () => {
            const scrollPositionFactor = window.scrollY + window.innerHeight / 3;

            for (const sectionId of sectionsToTrack) {
                const DOMelement = document.getElementById(sectionId);
                if (DOMelement) {
                    const topOffset = DOMelement.offsetTop;
                    const elementHeight = DOMelement.offsetHeight;

                    if (scrollPositionFactor >= topOffset && scrollPositionFactor < topOffset + elementHeight) {
                        setCurrentViewedSection(sectionId);
                        break;
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScrollTracking);
        return () => window.removeEventListener('scroll', handleScrollTracking);
    }, []);

    return (
        <div style={{ background: '#F8F6F2' }}>
            {/* The Landingscreen component houses your main Header capsule bar inside your framework layout */}
            <section id="home">
                <Landingscreen activeNavId={currentViewedSection} />
            </section>

            <section id="about">
                <About />
            </section>
            <DesignProcess />
            <AboutFounder />
            <MeetOurTeam />



            <section id="projects">
                <Projects />
            </section>
            <RecentWorkShowcase />

            {/* <TransformationShowcase /> */}
            <VideoShowcase />



            <ClientFeedbacks />

            <section id="contact">
                <ContactUs />
            </section>

            <Footer />
        </div>
    );
};

export default Homescreen;
